import React from 'react';
import { Col, DatePicker, Form, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TimePicker } from 'antd/es';

const DateSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Date')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Inizio pubblicazione')} name='start_publishing_at'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={6} />
      <Col offset={6} span={5}>
        <Form.Item label={t('Data inizio promozione')} name='date_from'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label={t('Inizio dalle ore')} name='time_from'>
          <TimePicker disabled={isView} format={'HH:mm'} />
        </Form.Item>
      </Col>
      <Col span={5}>
        <Form.Item label={t('Data fine promozione')} name='date_to'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label={t('Fino alle ore')} name='time_to'>
          <TimePicker disabled={isView} format={'HH:mm'} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(DateSection);
